import { render, staticRenderFns } from "./ProductosSlider.vue?vue&type=template&id=c120d74c&scoped=true&"
import script from "./ProductosSlider.vue?vue&type=script&lang=js&"
export * from "./ProductosSlider.vue?vue&type=script&lang=js&"
import style0 from "./ProductosSlider.vue?vue&type=style&index=0&id=c120d74c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c120d74c",
  null
  
)

export default component.exports